import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(public)/terms-and-conditions')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="h-svh overflow-y-auto">
      <div className="mx-auto my-8 max-w-5xl space-y-4">
        <h1 className="text-center text-lg">
          <strong>TERMOS DE USO</strong>
        </h1>
        <p>
          <strong>1. APRESENTAÇÃO, OBJETO E NATUREZA DA PLATAFORMA</strong>
          <br />A solução desenvolvida pela GPMED é caracterizada como um
          infoproduto digital, baseado em curadoria de conteúdo, pesquisa
          científica e práticas educacionais modernas, com a missão de
          fortalecer o conhecimento clínico, terapêutico e assistencial dos seus
          usuários, por meio de conteúdos técnicos, científicos e educacionais,
          <strong>
            sem caráter normativo, vinculante ou substitutivo de diretrizes
            clínicas oficiais ou da atuação profissional individualizada.
          </strong>
        </p>
        <p>
          A utilização da plataforma, pelo Revisor Médico, implica adesão
          voluntária e consciente às regras aqui estabelecidas, as quais visam
          assegurar a transparência, a segurança da informação, a proteção de
          dados pessoais e a conformidade com a legislação brasileira vigente.
        </p>
        <p>
          Nesse contexto, todas as práticas desenvolvidas no âmbito da
          plataforma encontram amparo, especialmente, nos seguintes diplomas
          legais:
          <p className="ml-4">
            – Lei Geral de Proteção de Dados Pessoais (Lei nº 13.709/2018 –
            LGPD), que disciplina o tratamento de dados pessoais com o objetivo
            de proteger os direitos fundamentais de liberdade e privacidade;
          </p>
          <p className="ml-4">
            – Marco Civil da Internet (Lei nº 12.965/2014), que estabelece os
            princípios, garantias, direitos e deveres para o uso da internet no
            Brasil, assegurando o sigilo, a proteção dos dados pessoais e a
            preservação da privacidade;
          </p>
          <p className="ml-4">
            – Código de Defesa do Consumidor (Lei nº 8.078/1990),{' '}
            <strong>
              no que for aplicável às relações estabelecidas entre a GPMED e os
              usuários finais da plataforma
            </strong>
            , não se confundindo com a natureza jurídica da relação mantida com
            o Revisor Médico.
          </p>
        </p>
        <p>
          O escopo de funcionalidades oferecido pela Plataforma Digital GPMED
          contempla, mas não se limita a:
          <p className="ml-4">
            – acesso a conteúdos educativos organizados por áreas médicas e
            especialidades;
          </p>
          <p className="ml-4">
            – consulta de materiais técnicos sobre terapêuticas, condutas
            clínicas e farmacologia aplicada;
          </p>
          <p className="ml-4">
            – organização de conteúdos por nível de formação profissional;
          </p>
          <p className="ml-4">
            – oferta de planos de acesso conforme o perfil do usuário;
          </p>
          <p className="ml-4">
            – envio de notificações e atualizações de conteúdo;
          </p>
          <p className="ml-4">
            – canal de comunicação institucional com usuários;
          </p>
          <p className="ml-4">– mecanismos de autenticação e segurança;</p>
          <p className="ml-4">– gestão de dados cadastrais e de pagamento;</p>
          <p className="ml-4">
            – solicitação de validação documental para acesso a categorias
            específicas de planos.
          </p>
        </p>
        <p>
          A GPMED LTDA declara expressamente que sua plataforma digital não
          substitui, em nenhuma hipótese, a conduta médica, não realiza
          atividades de telemedicina, consulta médica ou prescrição clínica
          direta, sendo sua atuação restrita à disseminação de conteúdo
          educacional,{' '}
          <strong>
            cujos materiais refletem o estado do conhecimento científico
            disponível à época de sua elaboração ou revisão, podendo sofrer
            atualização conforme a evolução das diretrizes e evidências
            científicas
          </strong>
          , não se confundindo com qualquer serviço médico-hospitalar.
        </p>
        <p>
          O presente instrumento busca proporcionar ao Revisor Médico total
          clareza sobre a natureza do ecossistema em que atuará, promovendo a
          conformidade legal, a proteção de direitos fundamentais e a
          observância de padrões éticos na relação entre empresa, conteúdo e
          profissionais revisores.
        </p>
        <p>
          A GPMED LTDA e o Revisor Médico não se responsabilizam por eventual
          desatualização superveniente do conteúdo em razão da evolução
          científica, normativa ou de diretrizes clínicas, sendo o material
          compatível com o estado do conhecimento à época da revisão.
        </p>

        <p>
          <strong>2. OBJETO E FINALIDADE</strong>
          <br />
          Os presentes Termos regulam a participação do Revisor Médico na
          plataforma GPMED, na qualidade de profissional autônomo responsável
          exclusivamente pela revisão técnica e validação científica de
          conteúdos educacionais em saúde disponibilizados pela GPMED LTDA.
        </p>
        <p>
          A atividade possui natureza estritamente técnica, editorial e
          educacional, não configurando, em nenhuma hipótese, prestação de
          serviços médicos assistenciais, atendimento clínico, consulta,
          prescrição, diagnóstico, telemedicina ou qualquer forma de relação
          médico-paciente.
        </p>

        <p>
          <strong>3. NATUREZA DA ATIVIDADE E INEXISTÊNCIA DE VÍNCULO</strong>
          <br />O Revisor Médico atuará de forma independente, sem qualquer
          vínculo empregatício, societário, associativo, hierárquico ou de
          subordinação com a GPMED LTDA.
        </p>

        <p>
          Não há controle de jornada, exclusividade, obrigação de volume mínimo
          de tarefas ou continuidade obrigatória. Cada revisão será objeto de
          aceite específico, com definição de tema, escopo, prazo e valor,
          inexistindo obrigação de aceitação de novas demandas.
        </p>
        <p>
          A atuação do Revisor não é exclusiva, sendo-lhe facultado prestar
          serviços a terceiros, inclusive plataformas congêneres, desde que não
          utilize informações confidenciais, metodologias internas ou ativos
          estratégicos da GPMED.
        </p>

        <p>
          <strong>4. CADASTRO E REQUISITOS</strong>
          <br />O cadastro como Revisor Médico está condicionado à comprovação
          de registro profissional válido no CRM, capacidade civil plena e
          fornecimento de dados verdadeiros, completos e atualizados.
        </p>
        <p>
          A GPMED poderá solicitar documentação complementar e suspender ou
          excluir o cadastro em caso de informações falsas, inconsistentes ou
          conduta incompatível com estes Termos.
        </p>

        <p>
          <strong>5. OBRIGAÇÕES DO REVISOR MÉDICO</strong>
          <br />O Revisor compromete-se a:
          <p className="ml-4">
            – realizar a revisão técnica com diligência, ética e observância às
            melhores práticas científicas vigentes à época da validação;
          </p>
          <p className="ml-4">
            – indicar referências técnicas e científicas quando aplicável;
          </p>
          <p className="ml-4">– respeitar os prazos aceitos;</p>
          <p className="ml-4">
            – não inserir orientações clínicas individualizadas;
          </p>
          <p className="ml-4">
            – não estabelecer contato direto com usuários da plataforma;
          </p>
          <p className="ml-4">– comunicar conflitos de interesse relevantes;</p>
          <p className="ml-4">– observar as políticas internas da GPMED.</p>
        </p>

        <p>
          <strong>5.1 COMPLIANCE ÉTICO E REGULATÓRIO</strong>
          <br />O Revisor Médico compromete-se a observar as normas éticas da
          profissão, as resoluções do Conselho Federal de Medicina (CFM) e as
          diretrizes do respectivo Conselho Regional de Medicina (CRM),
          abstendo-se de práticas que possam caracterizar publicidade médica
          irregular, captação indevida de clientela ou infração ética.
        </p>

        <p>
          <strong>
            6. RESPONSABILIDADE, INDEPENDÊNCIA TÉCNICA E LIMITAÇÃO
          </strong>
          <br />O Revisor responde exclusivamente pela correção técnica do
          conteúdo revisado no momento da validação.
        </p>
        <p>
          A GPMED não interfere no juízo técnico do Revisor, sendo vedada
          qualquer influência sobre conclusões científicas, ressalvados ajustes
          editoriais de forma e padronização.
        </p>
        <p>
          A GPMED não se responsabiliza por uso indevido, interpretação
          equivocada ou aplicação clínica por terceiros.
        </p>
        <p>
          Não há relação médico-paciente entre o Revisor e os usuários da
          plataforma.
        </p>

        <p>
          <strong>6.1 PROIBIÇÃO DE PLÁGIO E FONTES INIDÔNEAS</strong>
          <br />O Revisor declara que não utilizará conteúdo plagiado, material
          protegido por direitos autorais de terceiros sem autorização ou fontes
          científicas inidôneas, respondendo integralmente por eventuais
          violações de direitos autorais ou utilização de informações
          comprovadamente falsas.
        </p>
        <p>
          Eventuais reclamações, demandas judiciais ou extrajudiciais de
          terceiros por violação de direitos autorais decorrentes de conteúdo
          inserido ou validado pelo Revisor serão de sua exclusiva
          responsabilidade, obrigando-se a isentar e indenizar a GPMED por
          quaisquer prejuízos, sem prejuízo do direito de regresso.
        </p>

        <p>
          <strong>7. CESSÃO DE DIREITOS AUTORAIS</strong>
          <br />O Revisor cede à GPMED, de forma total, irrevogável,
          irretratável, definitiva e por prazo indeterminado, os direitos
          patrimoniais sobre os conteúdos revisados, autorizando sua utilização,
          edição, adaptação, reprodução, distribuição e comercialização, em
          qualquer meio e território, nos termos da Lei nº 9.610/1998.
        </p>

        <p>
          <strong>8. CONFIDENCIALIDADE E NÃO CONCORRÊNCIA</strong>
          <br />O Revisor compromete-se a manter sigilo absoluto sobre conteúdos
          não publicados, metodologias internas, critérios editoriais, dados
          estratégicos e informações sensíveis da GPMED.
        </p>
        <p>
          A violação da confidencialidade sujeitará o Revisor ao pagamento de
          multa compensatória mínima equivalente a{' '}
          <strong>R$5.000,00 (cinco mil reais)</strong>, sem prejuízo de
          indenização suplementar por perdas e danos, inclusive danos
          reputacionais.
        </p>

        <p>
          <strong>8.1 NÃO CONCORRÊNCIA (LIMITADA)</strong>
          <br />
          Pelo prazo de 12 meses após o desligamento, o Revisor compromete-se a
          não utilizar metodologias internas, fluxos de validação e materiais
          estratégicos da GPMED para desenvolvimento de produto ou serviço
          concorrente direto.
        </p>

        <p>
          <strong>9. REMUNERAÇÃO</strong>
          <br />A remuneração será definida por tarefa aceita, sem natureza
          salarial, inexistindo qualquer vínculo trabalhista, previdenciário ou
          indenizatório.
        </p>

        <p>
          <strong>10. RESCISÃO E DESLIGAMENTO</strong>
          <br />O Revisor poderá encerrar sua participação a qualquer tempo.
        </p>
        <p>
          A GPMED poderá suspender ou excluir o cadastro em caso de violação
          destes Termos, conduta incompatível ou risco jurídico à plataforma.
        </p>

        <p>
          <strong>11. ALTERAÇÕES DOS TERMOS</strong>
          <br />
          Os Termos poderão ser atualizados mediante publicação da nova versão
          na plataforma.
        </p>

        <p>
          <strong>12. MEDIAÇÃO PRÉVIA E FORO DE ELEIÇÃO</strong>
          <br />
          Antes do ajuizamento de qualquer ação judicial relacionada aos
          presentes Termos de Uso, as partes comprometem-se a submeter a
          controvérsia à <strong>tentativa de mediação extrajudicial</strong>, a
          ser realizada por meio digital, junto a câmara de mediação privada ou
          por ferramenta eletrônica da própria Plataforma, no prazo de até 15
          (quinze) dias úteis a contar da notificação da parte interessada.
        </p>
        <p>
          Esgotada a via conciliatória, elegem as partes o foro da Comarca de{' '}
          <strong>São José do Rio Preto/SP</strong>, com renúncia a qualquer
          outro, por mais privilegiado que seja.
        </p>
      </div>
    </div>
  );
}
